<a [routerLink]="[params.inRouterLink, params.value]" (click)="navigate(params.inRouterLink)">
  {{ params.value }}
</a>
<mat-chip [@currentAnimState]="currentAnimState" class="update-chip">
  {{ params.labelText }}
</mat-chip>
